import React, { useState } from "react";
import CollapseIcon from "../../assets/images/images_new/dropdown-icon.svg"
import ExpandIcon from "../../assets/images/images_new/ExpandIcon.svg"
import { useSidebar } from "context/SidebarContext";

const SidebarClose = (props)  => {

const { isOpen, setIsOpen } = useSidebar();

	const closeSidebar = () => {
		document.body.classList.add('leftSidebarClosed');
	}

	const openSidebar = () => {
		document.body.classList.remove('leftSidebarClosed');
	}

	const openCloseSidebar = () => {
		console.log("collapeeeee");
		
		document.body.classList.toggle('leftSidebarClosed');
		setIsOpen(!isOpen)
	}
    
	const openCloseSidebarMobile = () => {
		// document.body.classList.remove('leftSidebarClosed');
		if (document.body.classList.contains('leftSidebarClosed')) {
			document.body.classList.remove('openSidebar');
		} else {
			document.body.classList.add('openSidebar');
		}
	}

	return (
		<div className="sidebar-wrapper" style={{width:"auto"}}>
			<span className="toggleIcon closeSidebar d-none d-lg-inline" onClick={() => openCloseSidebar()}>
				<img src={isOpen ? ExpandIcon : CollapseIcon} alt="collapse icon" />
			</span>

			<span className="toggleIcon openSidebarMobile align-self-end pr-3" onClick={() => openCloseSidebarMobile()}>
				<img src="/images/new_dash/hamburger.png" alt="collapse icon" />
			</span>

			{/*<span className="openSidebar align-self-end mb-3 pr-3" onClick={() => OpenSidebar()}>
				<img src="/images/new_dash/toggleIcon.svg" />
			</span>*/}
		</div>
	);
}

export default SidebarClose